// extracted by mini-css-extract-plugin
export default {"footer":"SideFooter_footer__SPOGW","cluster":"SideFooter_cluster__vHsz5","account":"SideFooter_account__pPJ3y","item":"SideFooter_item__WX1zB","badge":"SideFooter_badge__Q4mZz"};